<template>
    <v-flex class="login-form">
        <div class="display-1 my-8 text-center">
            <img :src="`${publicPath}assets/img/logo-eduniversal.png`" style="max-width: 258px" class="mx-auto">
        </div>
        <v-card light="light" class="mt-10">
            <v-card-text>
                <div class="subheading text-center font-weight-bold display-4 mt-6 mb-10">
                    <template>Login</template>
                </div>

                <v-form class="px-8" v-on:submit.prevent="login">
                    <v-alert v-if="!isValid"
                             dense
                             outlined
                             type="error"
                    >
                        Login ou mot de passe est incorrect !
                    </v-alert>
                    <v-text-field
                            v-model="form.username"
                            light
                            outlined
                            large
                            rounded
                            append-icon="$user"
                            label="Username"
                    ></v-text-field>
                    <v-text-field
                            v-model="form.password"
                            light
                            outlined
                            large
                            rounded
                            hide-details="auto"
                            append-icon="$locks"
                            label="Password"
                            type="password"
                    ></v-text-field>
                    <p class="text-center">
                        <v-btn
                                x-large
                                rounded
                                class="purple darken-4 display-2 px-12 mt-4 text-capitalize"
                                type="submit"
                                :loading="isLoading"
                        >Login</v-btn>
                    </p>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
  import { AUTH_LOGIN } from '../../store/mutation-types';
  import { AbilityBuilder } from '@casl/ability';

  export default {
    name: "LoginForm",
    data() {
      return {
        form: {
          username: null,
          password: null,
        },
        isValid: true,
        isLoading: false,
      };
    },
    computed: {
    },
    methods: {
      async login() {
        try {
          this.isLoading = true;
          await this.$store.dispatch(AUTH_LOGIN, this.form);

          this.isValid = true;

          this.$router.push(
            this.$router.history.current.query.redirect || {
              name: 'Statistiques',
            },
          );
        } catch (e) {
          this.isValid = false;
          this.handleError(e);
        }

        this.isLoading = false;
      },
      updateAbility(user) {
        const { can, rules } = new AbilityBuilder();

        if (user.role === 'admin') {
          can('manage', 'all');
        } else {
          can('read', 'all');
        }

        this.$ability.update(rules);
      }
    },
  }
</script>

<style scoped>

</style>
